import { z } from 'zod';
import { PHONE_REGEX, isValidPhoneNumber } from './utils/phone';

export type DriverStatus = (typeof driverStatuses)[number];

export const driverStatuses = [
  'active',
  'available',
  'created',
  'in-transit',
  'suspended',
] as const;

export const driverZ = z.object({
  name: z.object({
    first: z.string(),
    last: z.string(),
  }),
  email: z.string().email(),
  phone: z
    .string()
    .regex(PHONE_REGEX, 'Invalid phone number format. Must be +1 followed by 10 digits')
    .refine(isValidPhoneNumber, 'Please enter a valid US phone number'),
  status: z.enum(driverStatuses),
});

export type DriverZ = z.infer<typeof driverZ>;
